<div class="target-runs-form">
  <sz-chip-row [options]="chipOptions" [value]="activePreset()" (valueChange)="onChipSelect($event)" />

  @if (customMode()) {
    <div class="target-runs-form__buffer">
      <span class="target-runs-form__buffer-label">{{ 'drills.targetRunsPicker.customLabel' | translate }}</span>
      <span class="target-runs-form__buffer-value">{{ customBuffer() || '0' }}</span>
    </div>
    <sz-numpad-grid [keys]="numpadKeys" (press)="onNumpadPress($event)" />
  }

  <sz-button variant="primary" [fullWidth]="true" [disabled]="isSubmitDisabled()" (click)="submit()">
    <sz-icon name="check" [size]="16" />
    {{ submitLabel() }}
  </sz-button>
</div>
